<template>
  <admin-layout :title="$t('Sale Details')">
    <div class="px-4 md:px-0">
      <div class="flex items-start justify-between print:hidden">
        <tec-section-title class="-mx-4 md:mx-0 mb-6">
          <template #title>
            <div class="flex items-center">
              <Link class="text-blue-600 hover:text-blue-700" :href="route('sales')">{{ $t('Sales') }}</Link>
              <span class="text-blue-600 font-medium mx-2">/</span>
              {{ $t('Number') }} {{ sale.number }}
            </div>
          </template>
          <template #description>{{ $t('Please review the sale details below') }}</template>
        </tec-section-title>
        <div class="flex">
          <button
            @click="print()"
            class="flex items-center justify-center mr-2 h-8 w-8 rounded-full text-gray-600 hover:text-gray-800 bg-gray-200 hover:bg-gray-300 focus:outline-none"
          >
            <icons name="printer" class="h-5 w-5" />
          </button>
          <Link
            v-if="$can('read-sales')"
            :href="route('notifications.sale', sale.id)"
            class="flex items-center justify-center mr-2 h-8 w-8 rounded-full text-gray-600 hover:text-gray-800 bg-gray-200 hover:bg-gray-300 focus:outline-none"
          >
            <icons name="email" class="h-5 w-5" />
          </Link>
          <Link
            v-if="$can('update-sales')"
            :href="route('sales.edit', sale.id)"
            class="flex items-center justify-center mr-2 h-8 w-8 rounded-full text-gray-600 hover:text-gray-800 bg-gray-200 hover:bg-gray-300 focus:outline-none"
          >
            <icons name="edit" class="h-5 w-5" />
          </Link>
        </div>
      </div>

      <sale-details v-if="sale" :sale="sale" class="mt-0 pt-0" />
    </div>
  </admin-layout>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3';
import SaleDetails from './Details.vue';
import AdminLayout from '@/Layouts/AdminLayout.vue';
import TecSectionTitle from '@/Jetstream/SectionTitle.vue';

export default {
  props: { sale: Object },
  components: { Head, Link, AdminLayout, SaleDetails, TecSectionTitle },
  methods: {
    print() {
      window.print();
    },
  },
};
</script>
